import { useState, useLayoutEffect } from 'react';

const STORAGE_KEY = 'gas-prices-theme';

function getInitialTheme() {
  if (typeof window === 'undefined') return null;
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch {
    /* localStorage bloqueado */
  }
  return null; // null = sistema
}

// Aplica o atributo antes do paint para evitar flash quando há escolha salva.
if (typeof document !== 'undefined') {
  const initial = getInitialTheme();
  if (initial) document.documentElement.dataset.theme = initial;
}

export default function useTheme() {
  const [theme, setTheme] = useState(getInitialTheme);

  useLayoutEffect(() => {
    if (theme) document.documentElement.dataset.theme = theme;
    else delete document.documentElement.dataset.theme;

    try {
      if (theme) localStorage.setItem(STORAGE_KEY, theme);
      else localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
  }, [theme]);

  const cycle = () => {
    setTheme((current) => (current === 'dark' ? 'light' : current === 'light' ? null : 'dark'));
  };

  // resolvedTheme: o que está efetivamente renderizado
  const systemDark =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches;
  const resolvedTheme = theme || (systemDark ? 'dark' : 'light');

  return { theme, resolvedTheme, cycle };
}
